import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Combobox } from '@headlessui/react';
import cls from './Combobox.module.css';
import { EmployersForSelect } from '../../../AddProject/SecondStep/useSecondStep';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon';

interface ComboboxCustomProps {
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    selectedPerson: any;
    setSelectedPerson: React.Dispatch<any>;
    query: string;
    validateError: string;
    setQuery: React.Dispatch<React.SetStateAction<string>>;
    isBottom?: boolean;
}

export function ComboboxCustom({
    employersList,
    onEmployersListSet,
    setSelectedPerson,
    selectedPerson,
    setQuery,
    query,
    validateError,
    isBottom,
}: ComboboxCustomProps) {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const inputRef = useRef(null);
    const optionsRef = useRef(null);

    useEffect(() => {
        if (selectedPerson) {
            setQuery(selectedPerson.display_name);
        }
    }, [selectedPerson]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSelectedPerson(null);
        setQuery(event.target.value);
        onEmployersListSet(event.target.value);
    };

    const handlerEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (employersList.length > 0) {
                handleSelect(employersList[0]);
            }
        }
    };

    const handleSelect = (person: EmployersForSelect) => {
        setSelectedPerson(person);
        onEmployersListSet(person.email);
        setIsOpen(false);
    };

    return (
        <div className={cls.combobox}>
            <Combobox value={selectedPerson} onChange={handlerEnter}>
                <div className={cls.inputWrapper}>
                    <Combobox.Input
                        autoComplete="off"
                        displayValue={(person: EmployersForSelect) => {
                            return person ? person.display_name : query;
                        }}
                        placeholder={i18next.t('Combobox.Input.Placeholder.text')}
                        className={classNames(cls.input, {
                            [cls.errorInput]: !!validateError,
                        })}
                        value={query}
                        onChange={handleInputChange}
                        onKeyDown={handlerEnter}
                        onFocus={() => {
                            buttonRef.current.click();
                            setIsOpen(true);
                        }}
                        ref={inputRef}
                    />
                    <Combobox.Button
                        style={{ display: 'none' }}
                        ref={buttonRef}
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </div>
                {isOpen && !!employersList.length && (
                    <Combobox.Options
                        className={classNames(cls.options, {
                            [cls.optionsBottom]: isBottom,
                            [cls.optionsTop]: !isBottom,
                        })}
                        ref={optionsRef}
                    >
                        {employersList.map((person) => (
                            <Combobox.Option
                                key={person.guid}
                                value={person}
                                className={({ active }) =>
                                    `${cls.option} ${active ? cls.active : ''}`
                                }
                            >
                                <div
                                    onClick={() => handleSelect(person)}
                                    className={cls.daDataItemContent}
                                >
                                    {person.avatar ? (
                                        <div className={cls.avatar}>
                                            <img src={person.avatar} alt={'avatar'} />
                                        </div>
                                    ) : (
                                        <div className={cls.avatarIcon}>
                                            <Icon iconName={'profileBigSize'} />
                                        </div>
                                    )}

                                    <div className={cls.nameEmployer}>{person.display_name}</div>
                                </div>
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                )}
            </Combobox>
            {validateError && <div className={cls.error}>{validateError}</div>}
        </div>
    );
}
